import type { NavSectionProps } from 'src/components/nav-section';

import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export const getNavData = (
  t: (key: string) => string,
  workspaceId?: string
): NavSectionProps['data'] => [
  {
    items: [
      {
        id: 'nav-overview',
        title: t('Overview'),
        path: paths.dashboard.overview,
        icon: <Iconify width={24} icon="solar:home-angle-bold-duotone" />,
        deepMatch: true,
      },
      {
        id: 'nav-content',
        title: t('Content'),
        path: workspaceId
          ? paths.dashboard.content(workspaceId, 'root')
          : paths.dashboard.legacyContent,
        icon: <Iconify width={24} icon="solar:file-bold-duotone" />,
        deepMatch: true,
      },
      {
        id: 'nav-deployments',
        title: t('Deployments'),
        path: paths.dashboard.deployments,
        icon: <Iconify width={24} icon="solar:share-bold" />,
        deepMatch: true,
      },
      {
        id: 'nav-groups',
        title: t('Groups'),
        path: paths.dashboard.groups,
        icon: <Iconify width={24} icon="solar:users-group-rounded-bold" />,
        deepMatch: true,
      },
      {
        id: 'nav-learners',
        title: t('Learners'),
        path: paths.dashboard.learners,
        icon: <Iconify width={24} icon="solar:user-id-bold" />,
        deepMatch: true,
      },
    ],
  },
];

export const navData = (
  t: (key: string) => string,
  workspaceId?: string
): NavSectionProps['data'] => getNavData(t, workspaceId);
